import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

export const getEvaluacionProcedimiento = async (IdEvaluacion) => {
    return await PrivateInterceptor(`Procedimientos/getList/${IdEvaluacion}`, 'GET');
}


export const getEvaluacionByIdProcedimiento = async (IdProcedimiento) => {
    return await PrivateInterceptor(`Procedimientos/Evaluacion/${IdProcedimiento}`, 'GET');
}

export const getPreguntaByIdEvaluacion = async (IdEvaluacion) => {
    return await PrivateInterceptor(`Procedimientos/Preguntas/${IdEvaluacion}`, 'GET');
}

export const getRespuestas = async (IdPregunta) => {
    return await PrivateInterceptor(`Procedimientos/getRespuestas/${IdPregunta}`, 'GET');
}
 
